var map = {
	"./0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270/logo.png": "./src/assets/tokens-list-main/assets/0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270/logo.png",
	"./0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6/logo.png": "./src/assets/tokens-list-main/assets/0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6/logo.png",
	"./0x1ca4a7c82019301CBb32Bbd8aE40a7617Ac6951d/logo.png": "./src/assets/tokens-list-main/assets/0x1ca4a7c82019301CBb32Bbd8aE40a7617Ac6951d/logo.png",
	"./0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174/logo.png": "./src/assets/tokens-list-main/assets/0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174/logo.png",
	"./0x4e5E55bAeEf3bc747D22123cE4ADE3661c916a3e/logo.png": "./src/assets/tokens-list-main/assets/0x4e5E55bAeEf3bc747D22123cE4ADE3661c916a3e/logo.png",
	"./0x6B175474E89094C44Da98b954EedeAC495271d0F/logo.png": "./src/assets/tokens-list-main/assets/0x6B175474E89094C44Da98b954EedeAC495271d0F/logo.png",
	"./0x6bcBC54262351007ce362b63E6fFd12fae85EB0E/logo.png": "./src/assets/tokens-list-main/assets/0x6bcBC54262351007ce362b63E6fFd12fae85EB0E/logo.png",
	"./0x6f8a06447Ff6FcF75d803135a7de15CE88C1d4ec/logo.png": "./src/assets/tokens-list-main/assets/0x6f8a06447Ff6FcF75d803135a7de15CE88C1d4ec/logo.png",
	"./0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619/logo.png": "./src/assets/tokens-list-main/assets/0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619/logo.png",
	"./0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063/logo.png": "./src/assets/tokens-list-main/assets/0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063/logo.png",
	"./0x920D37Fc843A304d0BA039900C70f555B501c5CD/logo.png": "./src/assets/tokens-list-main/assets/0x920D37Fc843A304d0BA039900C70f555B501c5CD/logo.png",
	"./0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png": "./src/assets/tokens-list-main/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png",
	"./0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1/logo.png": "./src/assets/tokens-list-main/assets/0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1/logo.png",
	"./0xc2132D05D31c914a87C6611C10748AEb04B58e8F/logo.png": "./src/assets/tokens-list-main/assets/0xc2132D05D31c914a87C6611C10748AEb04B58e8F/logo.png",
	"./0xdAC17F958D2ee523a2206206994597C13D831ec7/logo.png": "./src/assets/tokens-list-main/assets/0xdAC17F958D2ee523a2206206994597C13D831ec7/logo.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/tokens-list-main/assets sync recursive ^\\.\\/.*\\/logo\\.png$";